import React, { useState } from "react";
import { MdOutlineSearch, MdFilterAlt, MdOutlineFolderOpen, MdMoreVert } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AccountDetails from "../admin/pages/AccountDetails";
// import { useAccount } from '../context/AccountContext';
import { useSelector } from "react-redux";

const Header = ({ onToggleRules, isRulesActive, onNavigateToDrivers, onSearch }) => {
  const navigate = useNavigate();
  const { user, token, isAuthenticated, isLoading, error } = useSelector((state) => state.auth);
  const { accountId } = useSelector((state) => state.account);
  const [activeButton, setActiveButton] = useState("myDrivers");
  const [searchItem, setSearchItem] = useState("");
  console.log("header call: ", user);

  // const { accountId } = useAccount();
  console.log("🚀 Header component rendered with account_id:", accountId);

  const handleFilterClick = () => {
    if (onToggleRules) onToggleRules();
  };

  const handleSearchChange = (event) => {
    const searchInputItem = event.target.value;
    setSearchItem(searchInputItem);
    if(onSearch){
      console.log("handleSearchChange:onSearch>", searchItem);
      onSearch(searchInputItem);
    }
  }

  return (
    // Remove fixed positioning - let it be part of the normal flow
    <div className="w-full h-full flex items-center justify-between px-6 bg-white border-b border-gray-200">
      {/* Left: Search Bar */}
      <div className="relative w-64">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MdOutlineSearch className="h-4 w-4 text-gray-400" />
        </div>
        <input
          type="text"
          placeholder="Search..."
          className="block w-full pl-10 pr-3 py-2 border border-gray-200 rounded-lg text-sm placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 bg-gray-50/70"
          value={searchItem}
          onChange={handleSearchChange}
        />
      </div>

      {/* Center: Mini AccountDetails */}
      <div className="flex-1 flex justify-center px-4">
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-4 py-2 hover:shadow-md transition-shadow duration-200">
          <AccountDetails accountId={accountId} mini={true} />
        </div>
      </div>

      {/* Right: Icon Actions */}
      <div className="flex items-center space-x-5 text-gray-600">
        <ActionButton
          onClick={() => {
            setActiveButton("myDrivers");
            console.log("Navigating to DriversPage");
            onNavigateToDrivers && onNavigateToDrivers();
            navigate('?view=drivers');
          }}
          icon={<MdOutlineFolderOpen size={20} />}
          label="My Drivers"
          tooltip="View Drivers"
          isActive={activeButton === "myDrivers"}
        />

        <ActionButton
          onClick={() => {
            setActiveButton("myFilters");
            handleFilterClick();
          }}
          icon={<MdFilterAlt size={20} />}
          label={isRulesActive ? "Close Filters" : "My Filters"}
          tooltip="Manage Filters"
          isActive={activeButton === "myFilters"}
        />

        <ActionButton
          onClick={() => setActiveButton("myDocs")}
          icon={<MdOutlineFolderOpen size={20} />}
          label="My Docs"
          tooltip="Open Documentation"
          isActive={activeButton === "myDocs"}
        />

        <ActionButton
          icon={<MdMoreVert size={20} />}
          label="More"
          tooltip="More Options"
        />
      </div>
    </div>
  );
};

// Reusable Action Button Component
const ActionButton = ({ onClick, icon, label, tooltip, isActive = false }) => (
  <button
    onClick={onClick}
    className={`group flex flex-col items-center transition-all duration-200 ${isActive ? "text-blue-600" : "text-gray-600 hover:text-blue-600"
      }`}
    title={tooltip}
  >
    <div className="transform transition-transform group-hover:scale-105">
      {icon}
    </div>
    <span className="text-[10px] mt-0.5 font-medium">{label}</span>
  </button>
);

export default Header;